var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-227.828 -76.006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(227.828 76.007)",
    fill: "#dae0e7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H16a0,0,0,0,1,0,0V18.7A2.3,2.3,0,0,1,13.7,21H2.3A2.3,2.3,0,0,1,0,18.7V0A0,0,0,0,1,0,0Z",
    transform: "translate(248 97)",
    fill: "none",
    stroke: "#0d1c4b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 19,
    transform: "translate(246.5 93)",
    fill: "none",
    stroke: "#0d1c4b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 11,
    transform: "translate(253.5 102)",
    fill: "none",
    stroke: "#0d1c4b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 11,
    transform: "translate(258.5 102)",
    fill: "none",
    stroke: "#0d1c4b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,0H5A1,1,0,0,1,6,1V4A0,0,0,0,1,6,4H0A0,0,0,0,1,0,4V1A1,1,0,0,1,1,0Z",
    transform: "translate(253 89)",
    fill: "none",
    stroke: "#0d1c4b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ee08eee6c42e8e5acc21685c4f612d42.svg";
export { ForwardRef as ReactComponent };